/**
 * Extrai apenas números de uma string, removendo todos os outros caracteres
 * @param value - String que pode conter números e outros caracteres
 * @returns String contendo apenas números
 * @example
 * extractNumbers('(11) 99999-9999') // '11999999999'
 * extractNumbers('123.456.789-01') // '12345678901'
 */
export const extractNumbers = (value: string): string => {
  if (!value) return '';
  return value?.replace(/\D/g, '');
};
